'use client';

import {
  Drawer,
  DrawerTrigger,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerClose,
} from '@/components/ui/Drawer';
import Filter from './Filter';
import { X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';

export const MobileFilter = ({
  isPending,
  startTransition,
  scrollToBlogStart,
}) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile(768);

  useEffect(() => {
    if (!isMobile) setOpen(false);
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <div className="md:hidden">
      <Drawer direction="left" open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild>
          <div className="md:hidden bg-[#0711122B] p-[5px] border border-[#0C3438] rounded-[5px]">
            <div className="flex justify-center items-center w-6 h-6">
              <FilterIcon />
            </div>
          </div>
        </DrawerTrigger>
        <DrawerContent className="bg-[#020C0D] border-none w-full h-full text-white">
          <DrawerHeader className="hidden">
            <DrawerTitle>Filters</DrawerTitle>
            <DrawerDescription>Choose filter</DrawerDescription>
          </DrawerHeader>
          <div className="px-4 py-4 pt-12 overflow-y-auto">
            <Filter
              isSticky={false}
              isPending={isPending}
              startTransition={startTransition}
              scrollToBlogStart={scrollToBlogStart}
            />
          </div>

          <DrawerClose asChild>
            <button className="top-4 right-4 absolute hover:bg-[#071112] p-2 rounded-md transition">
              <X className="w-5 h-5 text-[#1FBCCB]" />
            </button>
          </DrawerClose>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

const FilterIcon = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 22.75C6.09 22.75 5.75 22.41 5.75 22V15C5.75 14.59 6.09 14.25 6.5 14.25C6.91 14.25 7.25 14.59 7.25 15V22C7.25 22.41 6.91 22.75 6.5 22.75Z"
        fill="#1FBCCB"
      />
      <path
        d="M6.5 5.75C6.09 5.75 5.75 5.41 5.75 5V2C5.75 1.59 6.09 1.25 6.5 1.25C6.91 1.25 7.25 1.59 7.25 2V5C7.25 5.41 6.91 5.75 6.5 5.75Z"
        fill="#1FBCCB"
      />
      <path
        d="M17.5 22.75C17.09 22.75 16.75 22.41 16.75 22V19C16.75 18.59 17.09 18.25 17.5 18.25C17.91 18.25 18.25 18.59 18.25 19V22C18.25 22.41 17.91 22.75 17.5 22.75Z"
        fill="#1FBCCB"
      />
      <path
        d="M17.5 9.75C17.09 9.75 16.75 9.41 16.75 9V2C16.75 1.59 17.09 1.25 17.5 1.25C17.91 1.25 18.25 1.59 18.25 2V9C18.25 9.41 17.91 9.75 17.5 9.75Z"
        fill="#1FBCCB"
      />
      <path
        d="M7.5 15.75H5.5C3.78 15.75 2.75 14.72 2.75 13V7C2.75 5.28 3.78 4.25 5.5 4.25H7.5C9.22 4.25 10.25 5.28 10.25 7V13C10.25 14.72 9.22 15.75 7.5 15.75ZM5.5 5.75C4.61 5.75 4.25 6.11 4.25 7V13C4.25 13.89 4.61 14.25 5.5 14.25H7.5C8.39 14.25 8.75 13.89 8.75 13V7C8.75 6.11 8.39 5.75 7.5 5.75H5.5Z"
        fill="#1FBCCB"
      />
      <path
        d="M18.5 19.75H16.5C14.78 19.75 13.75 18.72 13.75 17V11C13.75 9.28 14.78 8.25 16.5 8.25H18.5C20.22 8.25 21.25 9.28 21.25 11V17C21.25 18.72 20.22 19.75 18.5 19.75ZM16.5 9.75C15.61 9.75 15.25 10.11 15.25 11V17C15.25 17.89 15.61 18.25 16.5 18.25H18.5C19.39 18.25 19.75 17.89 19.75 17V11C19.75 10.11 19.39 9.75 18.5 9.75H16.5Z"
        fill="#1FBCCB"
      />
    </svg>
  );
};
